import { createContext } from "react";

/**
 * Provides the DOM node of the mobile header's tab-bar slot, or null.
 *
 * On mobile, MainPage renders a slot inside the fixed header and exposes it
 * here so the page's SectionTabbar can portal its tabs + actions into the
 * header instead of rendering in place. It is null on desktop (no mobile
 * header) and is deliberately overridden to null inside full-screen overlays
 * (e.g. ProfileOverview) so their tab bars don't hijack the global slot that
 * sits behind them.
 */
export const MobileHeaderSlotContext = createContext(null);

export default MobileHeaderSlotContext;
